/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 44);
/******/ })
/************************************************************************/
/******/ ({

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// var angular = require('angular');
// var _ = require('lodash');

(function () {
    'use strict';

    angular.module('app').config(['$routeProvider', function ($routeProvider) {
        $routeProvider.when('/home', {
            templateUrl: 'assets/home/home.html',
            controller: 'HomeController',
            controllerAs: 'vm',
            authorize: true
        }).otherwise({
            redirectTo: '/home'
        });
    }]).controller('HomeController', homeController);

    homeController.$inject = ['$scope', '$location', '$localStorage', '$sessionStorage', '$interval', 'configBaseLayers', 'configLayers', 'leafletData', 'markerService', 'vesselPathService', 'emissionControlAreaService', 'vesselService', 'cargoService'];

    function homeController($scope, $location, $localStorage, $sessionStorage, $interval, configBaseLayers, configLayers, leafletData, markerService, vesselPathService, emissionControlAreaService, vesselService, cargoService) {

        var vm = this;

        // build initial view and leaflet model
        var storage = $localStorage.$default({
            center: {
                lat: 50,
                lng: 10,
                zoom: 4
            },
            overlayDefaults: {
                seamarks: { visible: false },
                weather: { visible: false },
                clouds: { visible: false },
                precipitationForecasts: { visible: false },
                windSpeed: { visible: false },
                windStream: { visible: false },
                windBarb: { visible: false },
                surfacePressure: { visible: false },
                airTemperature: { visible: false },
                precipitation: { visible: false },
                significantWaveHeight: { visible: false },
                harbours: { visible: true },
                vessels: { visible: true },
                eca: { visible: false }
            },
            timeStep: 1,
            timeWaypoint: 3
        });

        angular.extend(vm, {
            error: '',
            clearLastError: function clearLastError() {
                vm.error = '';
            },
            localTime: "local",
            sidebarVisible: false,
            showBunkerAllowed: false,
            showBunker: false,
            showVesselSummary: true,
            showPositioning: true,
            lastVesselPath: '',
            vesselData: {},
            bunkerAis: {},
            bunkerCalculator: {},
            portCalls: {},
            cargo: {},
            cargoInformationActiveTab: 0,
            refreshInSeconds: 0,
            $storage: storage,
            defaults: {
                minZoom: 2,
                worldCopyJump: true
            },
            controls: {},
            layers: configBaseLayers(),
            paths: {},
            markers: {},
            events: { // http://leafletjs.com/reference-1.2.0.html#map-event
                map: {
                    enable: ['overlayadd', 'overlayremove', 'moveend'],
                    logic: "emit"
                },
                marker: {
                    enable: ['mouseover'],
                    logic: "emit"
                },
                path: {
                    enable: ['mouseover'],
                    logic: "emit"
                }
            },
            vesselInfoLoading: false,
            cargoDetailsLoading: false,
            timeStepActive: false,
            timeWaypointActive: false,
            searchArgs: $location.absUrl().indexOf('?') !== -1 ? _.chain($location.absUrl().split('?').pop()).split('&').map(_.ary(_.partial(_.split, _, '='), 1)).fromPairs().value() : ''
        });

        if (angular.isUndefined(vm.$storage.timeWaypoint)) {
            vm.$storage.timeWaypoint = 3;
        }

        emissionControlAreaService.getEmissionControlAreas().then(function (data) {
            var layers = configLayers($sessionStorage.environment.openWeatherMapApiKey, data);
            if ($sessionStorage.environment.removeLayers) {
                layers.overlays = _.pickBy(layers.overlays, function (overlay) {
                    return !overlay.url || !_.some($sessionStorage.environment.removeLayers, function (url) {
                        return _.includes(overlay.url, _.trim(url));
                    });
                });
            }

            _.forEach(storage.overlayDefaults, function (value, key) {
                var overlay = layers.overlays[key];
                if (!overlay) return;
                overlay.visible = value.visible;
            });

            vm.layers.overlays = layers.overlays;
        }).catch(function (e) {
            vm.error = 'unable to config layers: ' + e;
        });

        // create event handlers
        // path point tooltip
        $scope.$on('leafletDirectivePath.mouseover', function (event, path) {
            if (path.leafletObject.options.tooltip) {
                path.leafletObject.bindTooltip(path.leafletObject.options.tooltip).openTooltip();
                path.leafletObject.options.tooltip = '';
            }
        });

        // harbour, vessel tooltip
        $scope.$on('leafletDirectiveMarker.mouseover', function (event, marker) {
            if (marker.leafletObject.options.tooltip) {
                marker.leafletObject.bindTooltip(marker.leafletObject.options.tooltip).openTooltip();
                marker.leafletObject.options.tooltip = '';
            }
        });

        // vessel icon / text click
        $scope.$on('leafletDirectiveMarker.click', function (event, marker) {
            if (marker.layerName === 'vessels' && marker.model.showPath) vm.vesselArrowClicked(event, marker);
            if (marker.layerName === 'vessels' && !marker.model.showPath) vm.vesselNameClicked(event, marker);
        });

        // to save / restore tile / overlay switch state
        $scope.$on("leafletDirectiveMap.overlayadd", function (event, leafletOverlay) {
            var layerCode = _.findKey(vm.layers.overlays, { name: leafletOverlay.leafletEvent.name });
            if (vm.$storage.overlayDefaults[layerCode] === undefined) vm.$storage.overlayDefaults[layerCode] = { visible: true };else vm.$storage.overlayDefaults[layerCode].visible = true;
        });

        var removeListener = $scope.$on("leafletDirectiveMap.overlayremove", function (event, leafletOverlay) {
            var layerCode = _.findKey(vm.layers.overlays, { name: leafletOverlay.leafletEvent.name });
            // doRefresh removes layout and adds it again, but this is not event from overlay control (we cannot know who triggered!), do nothing and do not save as default!
            if (vm.layers.overlays[layerCode].doRefresh) return;
            vm.$storage.overlayDefaults[layerCode].visible = false;
            // hide paths and side bar (vessel info) if vessel layer not shown
            vm.paths = {};
            vm.sidebarVisible = false;
        });

        // important, logout destroys model and listner would remove all overlay settings from storage above
        $scope.$on('$destroy', removeListener);

        $scope.$on('leafletDirectiveMap.moveend', function () {
            if (vm.layers.overlays && vm.layers.overlays.weather && vm.layers.overlays.weather.visible) {
                leafletData.getMap().then(function (map) {
                    // on zoom change recreate weather icons
                    // previously created vessel and harbour must be kept!)
                    markerService.getMarkers(map.getBounds(), vm.$storage.center.zoom, vm.searchArgs.mmsi, $sessionStorage.environment.openWeatherMapApiKey, true).then(function (result) {
                        vm.markers = _.assign({}, _.filter(vm.markers, function (m) {
                            return m.layer !== 'weather';
                        }), result.markers);
                    }).catch(function (e) {
                        var message = e;
                        if (e.data && e.data.Message) {
                            message = e.data.Message;
                        }

                        vm.error = 'unable to get weather markers: ' + message;
                    });
                });
            }
        });

        vm.vesselArrowClicked = function (event, marker) {
            vm.vesselData = {};
            vm.portCalls = {};
            vm.sidebarVisible = false;
            vm.paths = {};
            if (marker.model.code === vm.lastVesselPath) {
                vm.lastVesselPath = '';
                return;
            }

            vm.showVesselPath(marker.model.code);
        };

        vm.showVesselPath = function (vesselCode) {
            if (!vesselCode) return;

            // load vessel (marker.modelName) path points using service
            var timeInHours;
            switch (vm.$storage.timeWaypoint) {
                case 1:
                    timeInHours = 12;
                    break;
                case 2:
                    timeInHours = 24;
                    break;
                case 3:
                    timeInHours = 48;
                    break;
                case 4:
                    timeInHours = 120; // 5 days
                    break;
                case 5:
                    timeInHours = 240; // 10 days
                    break;
                default:
                    throw new RangeError('Wrong timeWaypoint: ' + vm.$storage.timeWaypoint);
            }

            vesselPathService.getPath(vesselCode, timeInHours).then(function (data) {
                vm.lastVesselPath = vesselCode;
                vm.paths = data;
            }).catch(function (e) {
                var message = e;
                if (e.data && e.data.Message) {
                    message = e.data.Message;
                }

                vm.error = 'unable to get vessel path: ' + message;
            });
        };

        vm.vesselNameClicked = function (event, marker) {
            // click on any marker closes path
            vm.portCalls = {};
            vm.paths = {};
            vm.bunkerAis = {};
            vm.bunkerCalculator = {};
            vm.lastVesselPath = '';
            if (vm.vesselData && marker.model.code === vm.vesselData.VesselCode) {
                vm.vesselData = {};
                vm.sidebarVisible = false;
                return;
            }

            vm.sidebarVisible = true;
            vm.vesselInfoLoading = true;

            vesselService.getVesselDetails(marker.model.code, marker.model.lastReportDate).then(function (data) {
                var vesselInfo = data.d;
                vm.vesselInfoLoading = false;
                vm.vesselData = vesselInfo;

                // bunker values from reported AIS speed
                vm.calculateAisBunker();

                if (marker.model.nextPortId > 0) {
                    vm.cargoDetailsLoading = true;

                    cargoService.getCargoInfo(marker.model.code, marker.model.nextPortId).then(function (data) {
                        vm.cargoDetailsLoading = false;
                        if (data.d && data.d.portCalls) vm.portCalls = data.d.portCalls;
                        if (vm.portCalls && vm.portCalls.length > 0) {

                            var totalCargo = _.last(vm.portCalls);
                            // activate tab page having the most cargo on board
                            var orderCargoTypeByTons = _.reverse(_.sortBy([{ tabIndex: 0, tons: totalCargo.cargo.container.total.tons || -1 }, { tabIndex: 1, tons: totalCargo.cargo.breakBulk.tons || -2 }, { tabIndex: 2, tons: totalCargo.cargo.roro[0].tons || -3 }], "tons"));
                            vm.cargoInformationActiveTab = orderCargoTypeByTons[0].tabIndex;
                            vm.cargo.selectedPod = totalCargo;
                        }
                    }).catch(function (e) {
                        vm.cargoDetailsLoading = false;
                        var message = e;
                        if (e.data && e.data.Message) {
                            message = e.data.Message;
                        }

                        vm.error = 'unable to get cargo information: ' + message;
                    });
                }
            }).catch(function (e) {
                var message = e;
                if (e.data && e.data.Message) {
                    message = e.data.Message;
                }

                vm.error = 'unable to get vessel details: ' + message;
            });
        };

        // view contraller calls (modify view state)
        vm.calculateAisBunker = function () {
            vm.bunkerAis.speed = vm.vesselData.SpeedAis;
            vesselService.getBunkerConsumption(vm.vesselData.VesselCode, vm.vesselData.AisNextPort, vm.vesselData.SpeedAis).then(function (data) {
                vm.processBunkerResponse(vm.bunkerAis, data.d);
            }).catch(function (e) {
                var message = e;
                if (e.data && e.data.Message) {
                    message = e.data.Message;
                }

                vm.error = 'unable to calculate bunker values: ' + message;
            });
        };

        // view contraller calls (modify view state)
        vm.calculateBunker = function () {
            vesselService.getBunkerConsumption(vm.vesselData.VesselCode, vm.vesselData.AisNextPort, vm.bunkerCalculator.speed).then(function (data) {
                vm.processBunkerResponse(vm.bunkerCalculator, data.d);
            }).catch(function (e) {
                var message = e;
                if (e.data && e.data.Message) {
                    message = e.data.Message;
                }

                vm.error = 'unable to calculate bunker values: ' + message;
            });
        };

        vm.processBunkerResponse = function (bunkerCalculator, bunker) {
            if (_.startsWith(bunker.BunkerCostCosp, 'ERR-')) {
                bunkerCalculator.bunkerCosts = "Error";
                switch (bunker.BunkerCostCosp) {
                    case 'ERR-001':
                        bunkerCalculator.bunkerCostsError = 'Remaining distance to EOSP missing';
                        break;
                    case 'ERR-002':
                        bunkerCalculator.bunkerCostsError = 'Bunker consumption with speed range is missing in Masterdata';
                        break;
                    case 'ERR-003':
                        bunkerCalculator.bunkerCostsError = 'Speed is not valid';
                        break;
                    case 'ERR-004':
                        bunkerCalculator.bunkerCostsError = 'No price, bunker order is missing';
                        break;
                }
            } else {
                bunkerCalculator.bunkerCostsError = '';
                bunkerCalculator.bunkerCosts = (bunker.BunkerCostCosp || '') + ' ' + (bunker.BunkerCostCospCurrency || '');
            }
            bunkerCalculator.consumptionIfo = bunker.ConsumptionIfo;
            bunkerCalculator.consumptionMgo = bunker.ConsumptionMgo;
            bunkerCalculator.calculatedETA = bunker.CalculatedEta;
        };

        vm.closeSidebar = function () {
            vm.sidebarVisible = false;
            delete vm.cargoInformationActiveTab;
        };

        vm.timeStepChanged = function () {
            vm.timeStepActive = false;
            // to modify all at once
            var overlays = _.assign({}, vm.layers.overlays);
            _.forEach(vm.$storage.overlayDefaults, function (value, key) {
                var overlay = overlays[key];
                overlay.visible = value.visible;
                if (angular.isDefined(overlay.layerOptions) && angular.isDefined(overlay.layerOptions.timeStep)) {
                    overlay.layerOptions.timeStep = vm.getTimeStepHours(vm.$storage.timeStep);
                    overlay.doRefresh = true;
                }
            });

            vm.layers.overlays = overlays;
        };

        vm.getTimeStepHours = function (index) {
            return (index - 1) * (index <= 3 ? 6 : 12) - (index > 3 ? 12 : 0);
        };

        vm.timeWaypointChanged = function () {
            vm.timeWaypointActive = false;
            vm.showVesselPath(vm.lastVesselPath);
        };

        vm.getTimeWaypointHours = function (index) {
            var result;
            switch (index) {
                case 1:
                    result = "12h";
                    break;
                case 2:
                    result = "24h";
                    break;
                case 3:
                    result = "48h";
                    break;
                case 4:
                    result = "5d";
                    break;
                case 5:
                    result = "10d";
                    break;
                default:
                    throw new RangeError('Bad index: ' + index);
            }

            return result;
        };

        vm.getDate = function (date) {
            if (!date) return 'n/a';
            return vm.localTime === "local" ? date.Local : date.Utc;
        };
        // initial load / reload  harbour and vessel markers every 60 seconds
        var refreshIntervalInSeconds = 60;
        vm.refreshInSeconds = refreshIntervalInSeconds;
        $interval(function () {
            if (vm.refreshInSeconds === refreshIntervalInSeconds) {
                vm.error = '';
                leafletData.getMap().then(function (map) {
                    vm.markers = markerService.getMarkers(map.getBounds(), vm.$storage.center.zoom, vm.searchArgs.mmsi, vm.layers.overlays && vm.layers.overlays.weather && vm.layers.overlays.weather.visible ? $sessionStorage.environment.openWeatherMapApiKey : null, false).then(function (result) {
                        vm.markers = result.markers;

                        // add map ontrols if we got markers (only once), otherwise they are useless in any case
                        if (!vm.controls.scale) {
                            var controls = [markerService.createSummaryControl()({
                                position: 'topright'
                            }), markerService.createTimestepControl()({
                                position: 'topleft'
                            })];
                            // waypoints control only for SeaMap Admin (1001)
                            if ($sessionStorage.logonInfo.security.hasAdminRole) {

                                controls.push(markerService.createTimeWaypointControl()({
                                    position: 'topleft'
                                }));
                            } else {
                                // default 48 hours if control is not visible
                                vm.$storage.timeWaypoint = 3;
                            }
                            if ($sessionStorage.logonInfo.security.hasAdminOrAgentRole) vm.cargoInformationEnabled = true;
                            if ($sessionStorage.logonInfo.security.hasBunkerPlannerRole) vm.showBunkerAllowed = true;

                            vm.controls = { scale: true, custom: controls };
                        }
                    }).catch(function (e) {
                        var message = e;
                        // openweathermap.org
                        if (e.data && e.data.cod && e.data.message) {
                            message = e.data.message;
                        }
                        // softship web services
                        if (e.data && e.data.Message) {
                            message = e.data.Message;
                        }

                        vm.error = 'unable to get markers: ' + message;
                    });
                });
                vm.refreshInSeconds = 0;
            } else {
                vm.refreshInSeconds += 1;
            }
        }, 1000);
    }
})();

/***/ })

/******/ });


// WEBPACK FOOTER //
// homeController_f61149ed4534c2438558.js